import React from 'react';
import Image, { ImageProps } from 'next/image';
import styled from 'styled-components';

import backLayer from '@images/hub/banner/back-layer.png';
import frontLayer from '@images/hub/banner/front-layer.png';

const HubBannerImage = (props: ImageProps) => {
  return (
    <Wrapper>
      <ClipPathImage objectFit="cover" height={250} width={300} {...props} />
      <Image alt="" src={frontLayer} />
      <Image alt="" src={backLayer} />
    </Wrapper>
  );
};
const Wrapper = styled.div`
  display: grid;
  position: relative;

  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  > * {
    grid-area: 1 / 1 / 2 / 2; // stacking the images on each other
  }
`;

const ClipPathImage = styled(Image)`
  z-index: 10;
  mask-image: url('/artifacts/images/hub/banner/clippath-layer.svg');
  mask-size: 100% 100%;
`;

export default HubBannerImage;
